import {vmsApi as api, User} from '../vmsApi';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../store'
import {tokenStorage} from '../baseApi';

interface initialStateInterface {
    loginModalOpen: boolean;
    authState: 'login' | 'reset' | 'create';
    authMessage: string;
    initialEmail: string;
    user: User | null;
    showCompleteProfileBanner: boolean;
    showVerifyEmailBanner: boolean;
}

const initialState:initialStateInterface = {
    loginModalOpen: false,
    authState: 'login',
    authMessage: '',
    initialEmail: '',
    user: null,
    showCompleteProfileBanner: true,
    showVerifyEmailBanner: true
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        openLoginModal(state) {
            state.loginModalOpen = true;
        },
        closeLoginModal(state) {
            state.loginModalOpen = false;
            state.authMessage = '';
        },
        setAuthState(state, action) {
            state.authState = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
        api.endpoints.postUsersLogin.matchFulfilled,
        (state, { payload }) => {
            // Handle new response format with tokens (for browsers blocking third-party cookies)
            const response = payload;
            if (response.user && response.accessToken && response.refreshToken) {
                // New format: { user, accessToken, refreshToken }
                state.user = response.user;
                tokenStorage.setTokens(response.accessToken, response.refreshToken);
                console.log('[AUTH] Tokens stored in localStorage (cookie fallback)');
            } else {
                // Keep user in sync with the current API response shape.
                state.user = response.user ?? null;
            }
        }
        );
        builder.addMatcher(
        api.endpoints.getUsersMe.matchFulfilled,
        (state, {payload}) => {
            state.user = payload;
        });
        builder.addMatcher(
          api.endpoints.postUsersLogout.matchFulfilled,
          (state) => {
              document.cookie = "jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              tokenStorage.clearTokens(); // Clear localStorage tokens too
              state.user = null;
          });
    },
})


export const logoutUser = createAsyncThunk('users/logout', async (payload: void, {dispatch}) => {
    try {
        const result = dispatch(api.endpoints.postUsersLogout.initiate());
        await result;
    } catch (error) {
        console.error('Error during logout:', error);
    }
});

export const selectCurrentUser = (state: RootState) => state.auth.user

export default authSlice;
